import { render } from "./NewContainer.vue?vue&type=template&id=21b31012&scoped=true"
import script from "./NewContainer.vue?vue&type=script&lang=js"
export * from "./NewContainer.vue?vue&type=script&lang=js"

import "./NewContainer.vue?vue&type=style&index=0&id=21b31012&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b31012"]])

export default __exports__